import React, { useEffect } from "react";
import { MdClose } from "react-icons/md";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import userAvatar from "../../images/user_avatar.png";
import { fileBaseUrl, getUserDetail, logoutHandler } from "../../Utils/Helper";

function MobileSidebar({ navbarRef, NavHandler, sideBarItems }) {
    const { pathname } = useLocation();

    const { getUserInfo } = useSelector((state) => state.getEditProfile);

    useEffect(() => {
        navbarRef.current.style.width = "0%";
    }, [pathname]);

    return (
        <div className="overlay" ref={navbarRef}>
            <span className="closebtn" onClick={NavHandler}> <MdClose /> </span>
            <div className={"overlay-content"}>
                <div className="d-flex align-items-center text-white gap-2 mb-4">
                    <div className="mobile_sidebar_avatar">
                        {
                            getUserInfo && getUserInfo?.data?.image ?
                                <img src={`${fileBaseUrl}/${getUserInfo?.data?.image}`} alt='' />
                                :
                                <img src={getUserDetail()?.image ? `${fileBaseUrl}/${getUserDetail()?.image}` : userAvatar} alt='' />
                        }
                    </div>
                    <div>
                        {
                            getUserInfo && getUserInfo?.data?.user_name ?
                                <h4>{getUserInfo?.data?.user_name}</h4>
                                :
                                <h6>{getUserDetail()?.user_name}</h6>
                        }
                    </div>
                </div>
                {sideBarItems?.map((item, index) => {
                    return (
                        <Link key={item.path} to={item.path} className={pathname === item.path ? "nav-active" : "nav-link"}>
                            <span className="overlay-content-number"> {index < 9 ? `0${index + 1}` : `${index + 1}`} - </span>
                            {item.title}
                        </Link>
                    );
                })}
                <Link className={"nav-link"} onClick={logoutHandler}>
                    <span className="overlay-content-number"> 0{sideBarItems?.length + 1} - </span>
                    Logout
                </Link>
            </div>
        </div>
    );
}
export default MobileSidebar;